<style scoped>

</style>
<template>
  <div
    :style="{
      'overflow-y':'auto',
      'overflow-x':'hidden',
      height: containHeight+'px',
    }"
  >
    <RootInfo 
      :detail="detail"
      :loading="loading.getDetailLoading"
    />
    <ChildInfo 
      style="margin-top:20px"
      :parent-detail="detail"
      :child-info-arr="childInfoArr"
      :loading-hash="loading.getChildInfoArrLoading"
      @edit="editItem"
      @delete="deleteItem"
    >
      <div
        slot="button"
        style="padding:0 10px"
      >
        <v-btn
          v-if="detail.editable"
          depressed
          color="primary"
          @click="addNewOne"
        >
          新增
        </v-btn>
      </div>
    </ChildInfo>
    <ChildEditModal
      ref="childModal"
      :parent-detail="detail"
      @success="getDetail"
    />
  </div>
</template>
<script >
  import RootInfo from './components/RootInfo'
  import ChildInfo from './components/ChildInfo'
  import ChildEditModal from './components/ChildEditModal'
  import { 
    getbudgetOrderDetailFromFinApi,
    budgetOrderSubOrderDetailApi, 
    getbudgetOrderDetailFromBusinessApi, 
    budgetOrderDeleteSubOrderApi 
  } from './service'
  export default {
    components: {
      RootInfo,
      ChildInfo,
      ChildEditModal,
    },
    props: {
      type: Number
    },
    data() {
      return {
        loading: {
          getDetailLoading: false,
          getChildInfoArrLoading:{}
        },
        detail: {
          apply_reason: null,
          apply_team_id: null,
          apply_user: null,
          apply_user_id: null,
          created_at: null,
          del: null,
          id: null,
          name: null,
          stat_info: [],
          sub_orders: [],
          uid: null,
          updated_at: null
        },
        childInfoArr: []
      }
    },
    computed: {
      containHeight() {
        const window_height = this.$store.state.window_height;
        return window_height - 180;
      }
    },
    mounted() {
      this.getDetail()
    },
    methods: {
      addNewOne() {
        this.$refs.childModal.show()
      },
      getChildDetail(id, index) {
        this.loading.getChildInfoArrLoading[index] = true
        budgetOrderSubOrderDetailApi({id}).then(({ budget_sub_order } = {}) => {
          this.$set(this.childInfoArr, index, budget_sub_order)
          this.loading.getChildInfoArrLoading[index] = false
        })
      },
      getDetail() {
        const { id } = this.$router.currentRoute.query
        const getRootDetailApi = this.type === 1 ? getbudgetOrderDetailFromFinApi : getbudgetOrderDetailFromBusinessApi
        this.loading.getDetailLoading = true
        this.childInfoArr = []
        getRootDetailApi({id}).then(item => {
          this.loading.getChildInfoArrLoading = {}
          this.detail = item.budget_order
          this.detail.sub_orders && this.detail.sub_orders.forEach((info, index) => {
            if (info.visible === false) {
              this.childInfoArr[index] = info
              this.childInfoArr[index].disabled = true
              return 
            }
            this.childInfoArr[index] = null
            this.getChildDetail(info.id, index)
          });
        }).finally(() => {
          this.loading.getDetailLoading = false
        })
      },
      editItem(data) {
        this.$refs.childModal.show(data)
      },
      deleteItem(item) {
        const _this = this
        this.$vModal.confirm({
          title:'提示',
          content: '是否删除该子单？',
          loading:true,
          onOk({ stopLoading, destroy }) {
            budgetOrderDeleteSubOrderApi({id:item.id}).then(() => {
              this.$Message.success({
                content: '废弃成功!'
              });
              _this.getDetail()
              destroy()
            }).catch(() => {
              stopLoading()
            })
          }
        })
      }
    }
  }
</script>
